import React from 'react';

/**
 * Renders a plain-text document, turning **bold** spans into <strong>.
 * Builds React nodes only — never injects HTML.
 */
export function renderInlineBold(text) {
  if (!text) return null;
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, idx) =>
    idx % 2 === 1 ? <strong key={idx}>{part}</strong> : <React.Fragment key={idx}>{part}</React.Fragment>
  );
}
